import * as languages from './languages.js';
import { EventBus } from '@/plugins/EventBus'

//import {clearAllSelectedLabelFilters, clearFilters, setFilterCounter} from "./modules/filters";

export function getTableId(currentTarget) {
    const container = getContainer(currentTarget);
    const table = getTable(container);
    if (table) {
        return table.id;
    }

    return null;
}

export function getExpandColumns(table) {
    return JSON.parse(table.dataset.expandColumns)
}

export function getCheckAllOnInit(table) {
    return JSON.parse(table.dataset.checkAllOnInit)
}

export function getSumableColumns(table) {
    return JSON.parse(table.dataset.sumableColumns)
}

export function getTable(container) {
    return container.querySelector('.table-datatable[id]');
}

export function getTableElementById(id) {
    return document.querySelector(`.table-datatable[id="${id}"]`);
}

export function getForm(container) {
    return container.querySelector('.table-datatable-filter-form');
}

export function getFormToSerialize(container) {
    return $(container).find('.table-datatable-filter-form');
}

export function getSerializedFilters(container) {
    return $(getFormToSerialize(container)).serialize();
}

export function getUrl(container) {
    const table = getTable(container);
    try {
        return route(table.dataset.ajaxRoute, JSON.parse(table.dataset.ajaxRouteParmas))
    } catch (error) {
        return table.dataset.ajaxUrl;
    }
}

export function getLocale(container) {
    const table = getTable(container);

    return table.dataset.locale;
}

export function getTranslations(container) {
    return languages.translations[getLocale(container)];
}

export function getCurrentTableInstance(element) {

    const container = element.closest('.table-datatable-container');

    if (container) {
        const table = container.querySelector('.table-datatable[id]');
        return window.datatableInstances[table.id];
    }

    return null;
}

export function getCurrentTableInstanceById(id) {
    return window.datatableInstances[id];
}

export function reloadAjaxCell(table, id) {
    let interval
    let counter = 0
    interval = setInterval(function () {
        const tableElement = document.querySelector(`table[id="${id}"]`)
        const cells = !tableElement ? [] : tableElement.querySelectorAll('[data-reload-cell]');

        if (cells.length > 0 && counter < 5) {
            counter++
            $.ajax({
                url: table.ajax.url(),
                type: 'POST',
                data: table.ajax.params(),
                success: d => {
                    const emitedEvents = []
                    cells.forEach(cell => {
                        const tr = cell.closest('tr')
                        if (tr) {
                            const idTr = tr.getAttribute('id');
                            if (idTr) {
                                const idItem = parseInt(idTr.slice(0, idTr.indexOf("_")));
                                const row = d.data.find(object => object.id === idItem)
                                if (row && row.hasOwnProperty(cell.getAttribute('data-reload-cell'))) {
                                    const parentCell = cell.parentElement
                                    if (parentCell) {
                                        parentCell.innerHTML = row[cell.getAttribute('data-reload-cell')]
                                    }
                                }
                            }
                            tableElement.querySelectorAll('[data-dispatch-event]').forEach((selector) => {
                                if (!emitedEvents.includes(selector.dataset.dispatchEvent)) {
                                    emitedEvents.push(selector.dataset.dispatchEvent)
                                    window.dispatchEvent(new Event(selector.dataset.dispatchEvent));
                                }
                            })
                        }
                    })
                }
            })
        } else {
            //usunięcie tooltip poprzedniego HTML komórki i odświeżenie ustawień dla nowego
            clearInterval(interval)
            counter = 0
            $('.tooltip').tooltip('dispose')
            $('[data-toggle="tooltip"]').tooltip()
        }
    },5000)
}

export function reloadTable(id, clear) {
    clear = typeof clear !== 'undefined' ? clear : false;
    const table = getCurrentTableInstanceById(id);
    if (!table) {
        return;
    }
    $eventEmit('updateLimitFreemiumText', id)
    EventBus.$emit('updateLimitFreemiumText', id)
    if (clear) {
        const tableElement = $(`#${id}`)[0];
        if (!tableElement) {
            return;
        }

        const container = getContainer(tableElement);
        const searchField = container.querySelector('.table-datatable-global-searching input');
        if (searchField) {
            searchField.value = '';
        }
        table.search('').draw();
    } else {
        table.ajax.reload(null, false);
    }
}



export function getContainer(element) {
    return element.closest('.table-datatable-container');
}

export function getInstanceId(instance) {
    if (instance.sInstance) {
        return instance.sInstance;
    } else {
        return instance.id;
    }
}

export function getTableStateId(instance) {
    if (instance.dataset && typeof instance.dataset.tableStateId !== 'undefined') {
        return instance.dataset.tableStateId;
    }

    return getInstanceId(instance)
}

export function getCustomFilters(instance_id) {
    return localStorage.getItem(instance_id) != null ? JSON.parse(localStorage.getItem(instance_id)) : {};
}

export function getLoaderContainer(container) {
    return container.querySelector('.table-datatable-table-container');
}
